import { InjectionToken, NgModule, NgZone, PLATFORM_ID } from '@angular/core';
import { ENV, ENV_CONFIG } from '../env';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { CommonModule } from '@angular/common';

export const FIREBASE_TRADE = new InjectionToken('firebase project injector');
export const FIREBASE_MARCHE = new InjectionToken('firebase project injector');


export function AngularFireDB(platformId: any, zone: NgZone, env: ENV, projectId: string) {
    return new AngularFireDatabase(env.firebaseConfig[projectId], projectId, env.firebaseConfig[projectId].databaseURL,platformId,zone,null, null)
}

export function AngularFireAuthFact(platformId: any, zone: NgZone, env: ENV, projectId: string) {
    return new AngularFireAuth(env.firebaseConfig[projectId], projectId,platformId,zone, null, null,null, null,null,null)
}

export const FIREBASE_REFERENCES = {
 TRADE_FIREDB: 'trade-firedatabase',
 MARCHE_FIREDB: 'marche-firedatabase',
 TRADE_FIREAUTH: 'trade-fireauth',
 MARCHE_FIREAUTH: 'marche-fireauth'
};

@NgModule({
    declarations: [],
    providers:[
        {provide: FIREBASE_TRADE, useValue: 'firebaseTrade'},
        {provide: FIREBASE_MARCHE, useValue: 'firebaseMarche'},
        {
            provide: FIREBASE_REFERENCES.TRADE_FIREDB,
            deps: [PLATFORM_ID, NgZone, ENV_CONFIG,FIREBASE_TRADE],
            useFactory: AngularFireDB
        },
        {
            provide: FIREBASE_REFERENCES.MARCHE_FIREDB,
            deps: [PLATFORM_ID, NgZone, ENV_CONFIG,FIREBASE_MARCHE],
            useFactory: AngularFireDB
        },
        {
            provide: FIREBASE_REFERENCES.TRADE_FIREAUTH,
            deps: [PLATFORM_ID, NgZone, ENV_CONFIG, FIREBASE_TRADE],
            useFactory: AngularFireAuthFact
        },
        {
            provide: FIREBASE_REFERENCES.MARCHE_FIREAUTH,
            deps: [PLATFORM_ID, NgZone, ENV_CONFIG, FIREBASE_MARCHE],
            useFactory: AngularFireAuthFact
        }
    ],
    imports: [
        CommonModule
    ]
})

export class FirebaseModule {

}